import { ColumnDefinition } from "shared/components/UniversalTable/types/ColumnConfig";
import { AccessControlItem, AccessType, ACCESS_TYPE_LABELS } from "../types/accessControl";

export const ACCESS_CONTROL_COLUMNS: ColumnDefinition[] = [
  {
    id: "building",
    label: "Gebouw",
    sortKey: "building",
    minWidth: 120,
    defaultWeight: 2,
  },
  {
    id: "unit",
    label: "Unit",
    sortKey: "unit",
    minWidth: 120,
    defaultWeight: 2,
  },
  {
    id: "accessType",
    label: "Type Toegang",
    sortKey: "accessType",
    minWidth: 140,
    defaultWeight: 2,
  },
  {
    id: "keyLocation",
    label: "Locatie Sleutel",
    sortKey: "keyLocation",
    minWidth: 180,
    defaultWeight: 2,
  },
  {
    id: "additionalInfo",
    label: "Additionele informatie",
    sortKey: "additionalInfo",
    minWidth: 200,
    defaultWeight: 3,
  },
  {
    id: "detail",
    label: "Details",
    minWidth: 60,
    defaultWeight: 1,
  },
];

export const ACCESS_CONTROL_FILTER_SECTIONS = [
  {
    key: "accessType",
    label: "Type Toegang",
    options: Object.values(AccessType).map((type) => ({
      key: type,
      label: ACCESS_TYPE_LABELS[type],
    })),
    color: "moss" as const,
    multiSelect: true,
  },
  {
    key: "building",
    label: "Gebouw",
    options: [] as Array<{ key: string; label: string }>,
    color: "brick" as const,
    multiSelect: true,
    extractOptionsFromData: (rows: AccessControlItem[]) => {
      if (!Array.isArray(rows)) return [];
      const buildings = new Map<string, string>();
      rows.forEach((row) => {
        if (row.buildingId) {
          buildings.set(row.buildingId, row.building?.id || row.buildingId);
        }
      });
      return Array.from(buildings.entries()).map(([id, label]) => ({
        key: id,
        label: label,
      }));
    },
  },
];

export const ACCESS_CONTROL_GROUPBY_OPTIONS = [
  { key: "none", label: "Geen" },
  {
    key: "building",
    label: "Per gebouw",
    extractor: (row: AccessControlItem) =>
      row.building?.id || row.buildingId || "Onbekend",
  },
  {
    key: "accessType",
    label: "Per type toegang",
    extractor: (row: AccessControlItem) =>
      row.accessType
        ? ACCESS_TYPE_LABELS[row.accessType]
        : "Geen type",
  },
];
